import { AUTH_USE_HTTPONLY_COOKIE } from './authStorage'

const CSRF_COOKIE_NAME =
    process.env.REACT_APP_CSRF_COOKIE_NAME || 'XSRF-TOKEN'
const CSRF_HEADER_NAME =
    process.env.REACT_APP_CSRF_HEADER_NAME || 'X-XSRF-TOKEN'

const MUTATING_METHODS = new Set(['post', 'put', 'patch', 'delete'])

function readCookie(name) {
    if (typeof document === 'undefined') return null
    const match = document.cookie.match(
        new RegExp(`(?:^|; )${name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}=([^;]*)`)
    )
    return match ? decodeURIComponent(match[1]) : null
}

/** Headers to attach on POST/PUT/PATCH/DELETE when using cookie auth + double-submit CSRF. */
export function getCsrfHeaders(method) {
    if (!AUTH_USE_HTTPONLY_COOKIE) return {}
    const m = (method || 'get').toLowerCase()
    if (!MUTATING_METHODS.has(m)) return {}

    const token = readCookie(CSRF_COOKIE_NAME)
    if (!token) return {}

    return { [CSRF_HEADER_NAME]: token }
}
